import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import cleanObjectFromEmptyValues from 'commons/cleanObjectFromEmptyValues';
import usePdpId from 'components/consumer/PDP/state/context/usePdpId';
import usePdpSlug from 'components/consumer/PDP/state/context/usePdpSlug';

// Get variables object for any Apollo Client queries made on PDP. If product
// ID is available then only include that variable in the output, otherwise
// only include the slug. If neither slug or ID are available, skip the query.
const usePDPApolloQueryVariables = (t0, t1) => {
  const $ = _c(8);
  const idOverride = t0 === undefined ? null : t0;
  const slugOverride = t1 === undefined ? null : t1;
  const id = usePdpId();
  const slug = usePdpSlug();
  const finalProductId = idOverride || id;
  const t2 = finalProductId ? null : slugOverride || slug;
  let t3;
  if ($[0] !== finalProductId || $[1] !== t2) {
    t3 = cleanObjectFromEmptyValues({
      id: finalProductId,
      slug: t2
    });
    $[0] = finalProductId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const variables = t3;
  let t4;
  if ($[3] !== variables) {
    t4 = isEmpty(variables);
    $[3] = variables;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const skip = t4;
  let t5;
  if ($[5] !== skip || $[6] !== variables) {
    t5 = {
      variables,
      skip
    };
    $[5] = skip;
    $[6] = variables;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default usePDPApolloQueryVariables;